import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { RadioGroup as BaseRadioGroup } from '../../radio';
import classNames from 'classnames';

export type RadioGroupProps = Omit<
  VFFieldProps<React.ComponentProps<typeof BaseRadioGroup>>,
  'label'
> & { label?: string; children?: React.ReactNode };
export const RadioGroup = React.forwardRef<HTMLInputElement, RadioGroupProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      onChange: customOnChange,
      required,
      disabled,
      inlineValidation,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={classNames('form-radio-group-item', className)}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: FieldRenderProps<string>) => {
            return (
              <BaseRadioGroup
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                {...other}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
